import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ServicePagesComponent } from './service-pages.component';
import { FrequentlyQuestionsModule } from '../../shared/components/frequently-questions/frequently-questions.module';
import { StoriesCarouselModule } from '../../shared/components/stories-carousel/stories-carousel.module';

@NgModule({
  declarations: [ServicePagesComponent],
  imports: [
    CommonModule,
    FrequentlyQuestionsModule,
    StoriesCarouselModule
  ],
  exports: [ServicePagesComponent]
})
export class ServicePagesModule { }
